export default class UpdateModelVersionModel {
    id = null;
    assetId = null;
    positionX = null;
    positionY = null;
    positionZ = null;
    rotationX = null;
    rotationY = null;
    rotationZ = null;
    
    constructor(id, assetId, camera) {
        this.id = id;
        this.assetId = assetId;
        this.positionX = camera.positionX;
        this.positionY = camera.positionY;
        this.positionZ = camera.positionZ;
        this.rotationX = camera.rotationX;
        this.rotationY = camera.rotationY;
        this.rotationZ = camera.rotationZ;     
    }
}